import type { RawAffiliate, Affiliate } from './types'

export default function parse(rawAffiliate: RawAffiliate): Affiliate {
  const { name, address, city, countryShortCode, stateCode } = rawAffiliate

  return {
    name,
    address,
    city,
    countryShortCode,
    stateCode,
  }
}
